module.exports = __webpack_public_path__ + "static/media/testebenner.50b3ec75.png";